import { OnInit } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
var NoDataFoundComponent = /** @class */ (function () {
    function NoDataFoundComponent(translate) {
        this.translate = translate;
        this.warningMsg = 'No.data.found';
    }
    NoDataFoundComponent.prototype.ngOnInit = function () { };
    return NoDataFoundComponent;
}());
export { NoDataFoundComponent };
